import React, { forwardRef, memo } from 'react';
import { classNames } from '../../utils/classNames';
import type { LabelProps } from './Label.types';
import './Label.css';

const LabelComponent = forwardRef<HTMLLabelElement, LabelProps>(
  (
    {
      labelText = 'NEW COMMENT',
      htmlFor = 'comment',
      required = false,
      styleOverrides,
      className,
      children,
      layout = 'horizontal',
      ...restProps
    },
    ref
  ) => {
    const hasChildren = children && React.Children.count(children) > 0;

    return (
      <div className={classNames('label-wrapper', `label-wrapper--${layout}`)}>
        <label
          ref={ref}
          htmlFor={htmlFor}
          className={classNames('label', className)}
          style={styleOverrides}
          {...restProps}
        >
          <span className="label__text">
            {labelText}
            {required && <span className="label__required">*</span>}
          </span>
        </label>
        {hasChildren && <div className="label__children">{children}</div>}
      </div>
    );
  }
);

LabelComponent.displayName = 'Label';
export const Label = memo(LabelComponent);
export default Label;
